import React, { useEffect, useRef, useId } from 'react';
import { Loader, Trash2 } from 'lucide-react';

const ConfirmDialog = ({ isOpen, onClose, onConfirm, title, message, isProcessing }) => {
    const titleId = useId();
    const messageId = useId();
    const cancelBtnRef = useRef(null);

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (isOpen && e.key === 'Escape' && !isProcessing) {
                if (onClose) onClose();
            }
        };

        if (isOpen) {
            window.addEventListener('keydown', handleKeyDown);
            // Focus cancel button for accessibility
            const timer = setTimeout(() => {
                cancelBtnRef.current?.focus();
            }, 50);
            return () => {
                window.removeEventListener('keydown', handleKeyDown);
                clearTimeout(timer);
            };
        }
    }, [isOpen, onClose, isProcessing]);

    if (!isOpen) return null;

    const handleBackdropClick = () => {
        if (!isProcessing && onClose) {
            onClose();
        }
    };

    return (
        <div
            className="fixed inset-0 bg-black/60 z-[1050] flex justify-center items-center p-4 animate-fade-in"
            onClick={handleBackdropClick}
        >
            <div
                className="bg-white dark:bg-slate-800 rounded-2xl shadow-xl w-full max-w-sm"
                onClick={e => e.stopPropagation()}
                role="alertdialog"
                aria-modal="true"
                aria-labelledby={titleId}
                aria-describedby={messageId}
            >
                <div className="p-6 text-center">
                    <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-red-100 dark:bg-red-900/50">
                        <Trash2 className="h-6 w-6 text-red-600 dark:text-red-400" aria-hidden="true" />
                    </div>
                    <h3 id={titleId} className="mt-4 text-lg font-bold text-slate-900 dark:text-slate-100">{title}</h3>
                    <p id={messageId} className="mt-2 text-sm text-slate-600 dark:text-slate-400">{message}</p>
                </div>
                <div className="px-6 py-4 bg-slate-50 dark:bg-slate-800/50 flex justify-center gap-3 rounded-b-2xl">
                    <button
                        type="button"
                        onClick={onClose}
                        className="btn-secondary w-full"
                        disabled={isProcessing}
                        ref={cancelBtnRef}
                    >
                        Cancelar
                    </button>
                    <button
                        type="button"
                        onClick={onConfirm}
                        className="btn-primary bg-red-600 hover:bg-red-700 w-full"
                        disabled={isProcessing}
                    >
                        {isProcessing ? <Loader className="animate-spin mx-auto" /> : 'Sim, Confirmar'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmDialog;
